import React from 'react';
import { ProgrammeEventsCard } from './ProgrammeEventsCard';

export function ProgrammeEventsPage(){
  return(
    <>
      <ProgrammeEventsCard/>
    </>
  )
}